import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../components/shared/page-layout/page-layout.component';
import { ComparaisonComponent } from '../../components/comparaison/comparaison.component';

@Component({
  selector: 'app-devis-emprunteur',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent, ComparaisonComponent],
  templateUrl: './devis-emprunteur.component.html',
  styleUrl: './devis-emprunteur.component.scss'
})
export class DevisEmprunteurComponent {
  title = 'Devis Assurance Emprunteur';
  subtitle = 'Comparez les meilleures offres d\'assurance crédit immobilier';
  phoneNumber = '07 57 93 35 00';
  heroVideo = 'assets/videos/creditEmprunteur.mp4';
  breadcrumbs = [{ label: 'Devis Emprunteur', link: undefined }];
  prevPage = { title: 'Assurance Crédit Emprunteur', link: '/assurance-credit-emprunteur' };
  nextPage = { title: 'Contactez-nous', link: '/contact' };

  // Tab navigation
  devisTabs = [
    { label: 'Santé Particulier', route: '/devis-sante-particulier', icon: 'pi-user' },
    { label: 'Santé Professionnelle', route: '/devis-sante-professionnelle', icon: 'pi-briefcase' },
    { label: 'Emprunteur', route: '/devis-emprunteur', icon: 'pi-home' },
    { label: 'Prévoyance GAV', route: '/devis-prevoyance-gav', icon: 'pi-shield' },
    { label: 'Prévoyance IJH', route: '/devis-prevoyance-ijh', icon: 'pi-building' },
    { label: 'Prévoyance Obsèques', route: '/devis-prevoyance-obseques', icon: 'pi-heart' },
    { label: 'Prévoyance Décès', route: '/devis-prevoyance-deces', icon: 'pi-lock' },
    { label: 'Animaux', route: '/devis-animaux', icon: 'pi-star' },
    { label: 'PNO', route: '/devis-pno', icon: 'pi-building' }
  ];
  
  constructor() {}
}
